/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ProductIngredientFragment = {
  readonly __typename?: 'Ingredient';
  readonly id: string;
  readonly name: string;
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  readonly dietaryProperties: ReadonlyArray<{
    readonly __typename?: 'DietaryProperty';
    readonly id: string;
    readonly name: Types.DietaryPropertyKind;
  }>;
};

export type IngredientModificationFragment = {
  readonly __typename?: 'IngredientModification';
  readonly calories: number;
  readonly removalCost: number;
  readonly additionCost: number;
  readonly substitutionCost: number;
  readonly kind: string | null;
  readonly subKind: string | null;
  readonly outOfStock: boolean;
  readonly mixable: boolean;
  readonly isGrain: boolean;
  readonly ingredient: {
    readonly __typename?: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    readonly dietaryProperties: ReadonlyArray<{
      readonly __typename?: 'DietaryProperty';
      readonly id: string;
      readonly name: Types.DietaryPropertyKind;
    }>;
  };
};

export type IngredientModificationKindFragment = {
  readonly __typename?: 'IngredientModificationKind';
  readonly minAggregateQuantity: number;
  readonly maxAggregateQuantity: number;
  readonly freeAggregateQuantity: number;
  readonly allowMultipleQuantity: boolean;
  readonly modifications: ReadonlyArray<{
    readonly __typename?: 'IngredientModification';
    readonly calories: number;
    readonly removalCost: number;
    readonly additionCost: number;
    readonly substitutionCost: number;
    readonly kind: string | null;
    readonly subKind: string | null;
    readonly outOfStock: boolean;
    readonly mixable: boolean;
    readonly isGrain: boolean;
    readonly ingredient: {
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename?: 'DietaryProperty';
        readonly id: string;
        readonly name: Types.DietaryPropertyKind;
      }>;
    };
  }>;
};

export type ProductDetailsFragment = {
  readonly __typename?: 'Product';
  readonly id: string;
  readonly slug: string;
  readonly restaurantId: string;
  readonly name: string;
  readonly categoryId: string;
  readonly description: string;
  readonly cost: number;
  readonly calories: number;
  readonly outOfStock: boolean;
  readonly throttleItem: boolean;
  readonly maxModifications: number;
  readonly isModifiable: boolean;
  readonly isCustom: boolean;
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  readonly restaurant: {
    readonly __typename?: 'Restaurant';
    readonly id: string;
    readonly isOutpost: boolean;
  };
  readonly dietaryProperties: ReadonlyArray<{
    readonly __typename?: 'DietaryProperty';
    readonly id: string;
    readonly name: Types.DietaryPropertyKind;
  }>;
  readonly ingredients: ReadonlyArray<{
    readonly __typename?: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    readonly dietaryProperties: ReadonlyArray<{
      readonly __typename?: 'DietaryProperty';
      readonly id: string;
      readonly name: Types.DietaryPropertyKind;
    }>;
  }>;
  readonly ingredientModifications: {
    readonly __typename?: 'IngredientModifications';
    readonly bases: {
      readonly __typename?: 'IngredientModificationKind';
      readonly minAggregateQuantity: number;
      readonly maxAggregateQuantity: number;
      readonly freeAggregateQuantity: number;
      readonly allowMultipleQuantity: boolean;
      readonly modifications: ReadonlyArray<{
        readonly __typename?: 'IngredientModification';
        readonly calories: number;
        readonly removalCost: number;
        readonly additionCost: number;
        readonly substitutionCost: number;
        readonly kind: string | null;
        readonly subKind: string | null;
        readonly outOfStock: boolean;
        readonly mixable: boolean;
        readonly isGrain: boolean;
        readonly ingredient: {
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly dietaryProperties: ReadonlyArray<{
            readonly __typename?: 'DietaryProperty';
            readonly id: string;
            readonly name: Types.DietaryPropertyKind;
          }>;
        };
      }>;
    };
    readonly toppings: {
      readonly __typename?: 'IngredientModificationKind';
      readonly minAggregateQuantity: number;
      readonly maxAggregateQuantity: number;
      readonly freeAggregateQuantity: number;
      readonly allowMultipleQuantity: boolean;
      readonly modifications: ReadonlyArray<{
        readonly __typename?: 'IngredientModification';
        readonly calories: number;
        readonly removalCost: number;
        readonly additionCost: number;
        readonly substitutionCost: number;
        readonly kind: string | null;
        readonly subKind: string | null;
        readonly outOfStock: boolean;
        readonly mixable: boolean;
        readonly isGrain: boolean;
        readonly ingredient: {
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly dietaryProperties: ReadonlyArray<{
            readonly __typename?: 'DietaryProperty';
            readonly id: string;
            readonly name: Types.DietaryPropertyKind;
          }>;
        };
      }>;
    };
    readonly premiums: {
      readonly __typename?: 'IngredientModificationKind';
      readonly minAggregateQuantity: number;
      readonly maxAggregateQuantity: number;
      readonly freeAggregateQuantity: number;
      readonly allowMultipleQuantity: boolean;
      readonly modifications: ReadonlyArray<{
        readonly __typename?: 'IngredientModification';
        readonly calories: number;
        readonly removalCost: number;
        readonly additionCost: number;
        readonly substitutionCost: number;
        readonly kind: string | null;
        readonly subKind: string | null;
        readonly outOfStock: boolean;
        readonly mixable: boolean;
        readonly isGrain: boolean;
        readonly ingredient: {
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly dietaryProperties: ReadonlyArray<{
            readonly __typename?: 'DietaryProperty';
            readonly id: string;
            readonly name: Types.DietaryPropertyKind;
          }>;
        };
      }>;
    };
    readonly dressings: {
      readonly __typename?: 'IngredientModificationKind';
      readonly minAggregateQuantity: number;
      readonly maxAggregateQuantity: number;
      readonly freeAggregateQuantity: number;
      readonly allowMultipleQuantity: boolean;
      readonly modifications: ReadonlyArray<{
        readonly __typename?: 'IngredientModification';
        readonly calories: number;
        readonly removalCost: number;
        readonly additionCost: number;
        readonly substitutionCost: number;
        readonly kind: string | null;
        readonly subKind: string | null;
        readonly outOfStock: boolean;
        readonly mixable: boolean;
        readonly isGrain: boolean;
        readonly ingredient: {
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly dietaryProperties: ReadonlyArray<{
            readonly __typename?: 'DietaryProperty';
            readonly id: string;
            readonly name: Types.DietaryPropertyKind;
          }>;
        };
      }>;
    };
    readonly bread: {
      readonly __typename?: 'IngredientModificationKind';
      readonly minAggregateQuantity: number;
      readonly maxAggregateQuantity: number;
      readonly freeAggregateQuantity: number;
      readonly allowMultipleQuantity: boolean;
      readonly modifications: ReadonlyArray<{
        readonly __typename?: 'IngredientModification';
        readonly calories: number;
        readonly removalCost: number;
        readonly additionCost: number;
        readonly substitutionCost: number;
        readonly kind: string | null;
        readonly subKind: string | null;
        readonly outOfStock: boolean;
        readonly mixable: boolean;
        readonly isGrain: boolean;
        readonly ingredient: {
          readonly __typename?: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly dietaryProperties: ReadonlyArray<{
            readonly __typename?: 'DietaryProperty';
            readonly id: string;
            readonly name: Types.DietaryPropertyKind;
          }>;
        };
      }>;
    };
  };
};

export type GetProductQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type GetProductQuery = {
  readonly __typename?: 'Query';
  readonly product: {
    readonly __typename?: 'Product';
    readonly id: string;
    readonly slug: string;
    readonly restaurantId: string;
    readonly name: string;
    readonly categoryId: string;
    readonly description: string;
    readonly cost: number;
    readonly calories: number;
    readonly outOfStock: boolean;
    readonly throttleItem: boolean;
    readonly maxModifications: number;
    readonly isModifiable: boolean;
    readonly isCustom: boolean;
    readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
    readonly restaurant: {
      readonly __typename?: 'Restaurant';
      readonly id: string;
      readonly isOutpost: boolean;
    };
    readonly dietaryProperties: ReadonlyArray<{
      readonly __typename?: 'DietaryProperty';
      readonly id: string;
      readonly name: Types.DietaryPropertyKind;
    }>;
    readonly ingredients: ReadonlyArray<{
      readonly __typename?: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename?: 'DietaryProperty';
        readonly id: string;
        readonly name: Types.DietaryPropertyKind;
      }>;
    }>;
    readonly ingredientModifications: {
      readonly __typename?: 'IngredientModifications';
      readonly bases: {
        readonly __typename?: 'IngredientModificationKind';
        readonly minAggregateQuantity: number;
        readonly maxAggregateQuantity: number;
        readonly freeAggregateQuantity: number;
        readonly allowMultipleQuantity: boolean;
        readonly modifications: ReadonlyArray<{
          readonly __typename?: 'IngredientModification';
          readonly calories: number;
          readonly removalCost: number;
          readonly additionCost: number;
          readonly substitutionCost: number;
          readonly kind: string | null;
          readonly subKind: string | null;
          readonly outOfStock: boolean;
          readonly mixable: boolean;
          readonly isGrain: boolean;
          readonly ingredient: {
            readonly __typename?: 'Ingredient';
            readonly id: string;
            readonly name: string;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: Types.DietaryPropertyKind;
            }>;
          };
        }>;
      };
      readonly toppings: {
        readonly __typename?: 'IngredientModificationKind';
        readonly minAggregateQuantity: number;
        readonly maxAggregateQuantity: number;
        readonly freeAggregateQuantity: number;
        readonly allowMultipleQuantity: boolean;
        readonly modifications: ReadonlyArray<{
          readonly __typename?: 'IngredientModification';
          readonly calories: number;
          readonly removalCost: number;
          readonly additionCost: number;
          readonly substitutionCost: number;
          readonly kind: string | null;
          readonly subKind: string | null;
          readonly outOfStock: boolean;
          readonly mixable: boolean;
          readonly isGrain: boolean;
          readonly ingredient: {
            readonly __typename?: 'Ingredient';
            readonly id: string;
            readonly name: string;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: Types.DietaryPropertyKind;
            }>;
          };
        }>;
      };
      readonly premiums: {
        readonly __typename?: 'IngredientModificationKind';
        readonly minAggregateQuantity: number;
        readonly maxAggregateQuantity: number;
        readonly freeAggregateQuantity: number;
        readonly allowMultipleQuantity: boolean;
        readonly modifications: ReadonlyArray<{
          readonly __typename?: 'IngredientModification';
          readonly calories: number;
          readonly removalCost: number;
          readonly additionCost: number;
          readonly substitutionCost: number;
          readonly kind: string | null;
          readonly subKind: string | null;
          readonly outOfStock: boolean;
          readonly mixable: boolean;
          readonly isGrain: boolean;
          readonly ingredient: {
            readonly __typename?: 'Ingredient';
            readonly id: string;
            readonly name: string;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: Types.DietaryPropertyKind;
            }>;
          };
        }>;
      };
      readonly dressings: {
        readonly __typename?: 'IngredientModificationKind';
        readonly minAggregateQuantity: number;
        readonly maxAggregateQuantity: number;
        readonly freeAggregateQuantity: number;
        readonly allowMultipleQuantity: boolean;
        readonly modifications: ReadonlyArray<{
          readonly __typename?: 'IngredientModification';
          readonly calories: number;
          readonly removalCost: number;
          readonly additionCost: number;
          readonly substitutionCost: number;
          readonly kind: string | null;
          readonly subKind: string | null;
          readonly outOfStock: boolean;
          readonly mixable: boolean;
          readonly isGrain: boolean;
          readonly ingredient: {
            readonly __typename?: 'Ingredient';
            readonly id: string;
            readonly name: string;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: Types.DietaryPropertyKind;
            }>;
          };
        }>;
      };
      readonly bread: {
        readonly __typename?: 'IngredientModificationKind';
        readonly minAggregateQuantity: number;
        readonly maxAggregateQuantity: number;
        readonly freeAggregateQuantity: number;
        readonly allowMultipleQuantity: boolean;
        readonly modifications: ReadonlyArray<{
          readonly __typename?: 'IngredientModification';
          readonly calories: number;
          readonly removalCost: number;
          readonly additionCost: number;
          readonly substitutionCost: number;
          readonly kind: string | null;
          readonly subKind: string | null;
          readonly outOfStock: boolean;
          readonly mixable: boolean;
          readonly isGrain: boolean;
          readonly ingredient: {
            readonly __typename?: 'Ingredient';
            readonly id: string;
            readonly name: string;
            readonly asset: {
              readonly __typename?: 'Asset';
              readonly url: string;
            };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename?: 'DietaryProperty';
              readonly id: string;
              readonly name: Types.DietaryPropertyKind;
            }>;
          };
        }>;
      };
    };
  };
};

export const getProductQueryMock: ExecutionResult<GetProductQuery> = {
  data: {
    product: {
      id: 'e509e6ea-9fee-442a-9962-587ce7190430',
      slug: 'Hello World',
      restaurantId: '8da7a716-3ba7-4eda-96e8-a185e3da00a9',
      name: 'Hello World',
      categoryId: 'Hello World',
      description: 'Hello World',
      cost: 36,
      calories: -48,
      outOfStock: false,
      throttleItem: false,
      maxModifications: -61,
      isModifiable: false,
      isCustom: false,
      asset: { url: 'Hello World' },
      restaurant: {
        id: '19d08060-b59a-4a25-8f9c-4016b1bd634c',
        isOutpost: true,
      },
      dietaryProperties: [
        { id: '73b7f9f1-8d03-40f1-b1f2-c49f5fd7994c', name: 'DAIRY' },
      ],
      ingredients: [
        {
          id: 'dcab38b7-485a-4fbe-8853-2ede7a1daa93',
          name: 'Hello World',
          asset: { url: 'Hello World' },
          dietaryProperties: [
            { id: 'e0e095a7-b48f-40bb-960d-0180d39ca0c0', name: 'DAIRY' },
          ],
        },
        {
          id: '520a352a-4a65-441b-9bc5-d089f52e921d',
          name: 'Hello World',
          asset: { url: 'Hello World' },
          dietaryProperties: [
            { id: '1bfdfbab-d38f-4df8-ab15-0587b384c482', name: 'DAIRY' },
            { id: '99be511f-9b1e-439b-ad74-afbe52f8a3a6', name: 'DAIRY' },
          ],
        },
        {
          id: 'f32f0eda-ef12-4281-8af2-91521b27f2ba',
          name: 'Hello World',
          asset: { url: 'Hello World' },
          dietaryProperties: [
            { id: 'd9c8f96f-010c-4a15-b964-29788b394138', name: 'DAIRY' },
            { id: 'd5004934-e080-4ad7-bd62-514dd94f36b4', name: 'DAIRY' },
            { id: '1c23d4c4-b96c-4aa8-a22a-517d3cbc3f05', name: 'DAIRY' },
          ],
        },
      ],
      ingredientModifications: {
        bases: {
          minAggregateQuantity: -81,
          maxAggregateQuantity: -20,
          freeAggregateQuantity: -1,
          allowMultipleQuantity: true,
          modifications: [
            {
              calories: -27.32,
              removalCost: 3.14,
              additionCost: 71.39,
              substitutionCost: -44.47,
              kind: 'Hello World',
              subKind: 'Hello World',
              outOfStock: false,
              ingredient: {
                id: '1b931366-3db9-4eb2-b517-f534a27f5acf',
                name: 'Hello World',
                asset: { url: 'Hello World' },
                dietaryProperties: [
                  { id: 'da03bfaf-7e27-4a59-a381-e64855fe3c24', name: 'DAIRY' },
                  { id: '70d5f38a-ff27-4422-8629-33169f0cff6a', name: 'DAIRY' },
                  { id: '9347d88d-8eee-430f-a2b9-44d253ab94c4', name: 'DAIRY' },
                ],
              },
              mixable: false,
              isGrain: false,
            },
          ],
        },
        toppings: {
          minAggregateQuantity: -62,
          maxAggregateQuantity: -100,
          freeAggregateQuantity: -12,
          allowMultipleQuantity: false,
          modifications: [
            {
              calories: -45.27,
              removalCost: 56.75,
              additionCost: -31.68,
              substitutionCost: -26.77,
              kind: 'Hello World',
              subKind: 'Hello World',
              outOfStock: true,
              ingredient: {
                id: '9f516095-e6ed-4edc-961a-aeec36e40545',
                name: 'Hello World',
                asset: { url: 'Hello World' },
                dietaryProperties: [
                  { id: '8c254bfa-7591-4352-91a9-5511cbad1e17', name: 'DAIRY' },
                  { id: '1218cef4-b3e4-48fb-8e31-ab26ed5bc4c8', name: 'DAIRY' },
                  { id: 'c1e299d2-0348-4533-85b5-d1d6c3a3f028', name: 'DAIRY' },
                ],
              },
              mixable: true,
              isGrain: false,
            },
            {
              calories: 26.91,
              removalCost: 83.6,
              additionCost: 66.01,
              substitutionCost: -18.89,
              kind: 'Hello World',
              subKind: 'Hello World',
              outOfStock: false,
              ingredient: {
                id: '622b1666-8544-46f4-ace3-1741c5d1bce9',
                name: 'Hello World',
                asset: { url: 'Hello World' },
                dietaryProperties: [
                  { id: '1301d3f8-c0a7-4ac5-8fdb-bcdd3501c158', name: 'DAIRY' },
                ],
              },
              mixable: true,
              isGrain: false,
            },
          ],
        },
        premiums: {
          minAggregateQuantity: -84,
          maxAggregateQuantity: -57,
          freeAggregateQuantity: -36,
          allowMultipleQuantity: true,
          modifications: [
            {
              calories: -69.34,
              removalCost: 33.79,
              additionCost: -5.1,
              substitutionCost: 5.35,
              kind: 'Hello World',
              subKind: 'Hello World',
              outOfStock: true,
              ingredient: {
                id: '34f8c519-c93f-4c53-938f-da43a0d98038',
                name: 'Hello World',
                asset: { url: 'Hello World' },
                dietaryProperties: [
                  { id: 'a5f9c5de-b883-4501-8de5-6c37eabd31d4', name: 'DAIRY' },
                ],
              },
              mixable: true,
              isGrain: false,
            },
            {
              calories: 53.2,
              removalCost: -74.75,
              additionCost: 3.78,
              substitutionCost: 62.28,
              kind: 'Hello World',
              subKind: 'Hello World',
              outOfStock: true,
              ingredient: {
                id: '3a196f20-5d87-4fd3-b23c-3c4c78fe96f0',
                name: 'Hello World',
                asset: { url: 'Hello World' },
                dietaryProperties: [
                  { id: 'c6c7c7ef-3fd6-47f2-9d94-0ac3a65d867d', name: 'DAIRY' },
                  { id: '828cb8f2-533a-4adc-a114-c46d72b99b38', name: 'DAIRY' },
                  { id: 'd4361b55-e697-418e-9999-2088fef6ff29', name: 'DAIRY' },
                ],
              },
              mixable: true,
              isGrain: false,
            },
          ],
        },
        dressings: {
          minAggregateQuantity: -75,
          maxAggregateQuantity: 25,
          freeAggregateQuantity: 29,
          allowMultipleQuantity: false,
          modifications: [
            {
              calories: 97.74,
              removalCost: 73.28,
              additionCost: -62.41,
              substitutionCost: -73.53,
              kind: 'Hello World',
              subKind: 'Hello World',
              outOfStock: false,
              ingredient: {
                id: 'a9355665-b630-4e90-b365-84a270215897',
                name: 'Hello World',
                asset: { url: 'Hello World' },
                dietaryProperties: [
                  { id: 'dae467d6-e8a1-4a75-8372-c495169c3a63', name: 'DAIRY' },
                  { id: '266752cc-bff5-4c45-8d24-c5a557cfc091', name: 'DAIRY' },
                ],
              },
              mixable: true,
              isGrain: false,
            },
            {
              calories: -55.97,
              removalCost: 31.8,
              additionCost: 68.01,
              substitutionCost: -25.61,
              kind: 'Hello World',
              subKind: 'Hello World',
              outOfStock: false,
              ingredient: {
                id: '97815827-8f15-47f3-a6b1-e15ebc6183a3',
                name: 'Hello World',
                asset: { url: 'Hello World' },
                dietaryProperties: [
                  { id: '73ebe8d8-e2b4-4a3a-a596-dfcaff7e4b7b', name: 'DAIRY' },
                  { id: 'cfdb158b-5bd6-4c86-ba51-dc9c37e868bb', name: 'DAIRY' },
                  { id: 'd3352e54-c6a5-4739-a445-6bf2674ac27c', name: 'DAIRY' },
                ],
              },
              mixable: true,
              isGrain: false,
            },
            {
              calories: 71.87,
              removalCost: 75.95,
              additionCost: -34.93,
              substitutionCost: 37.8,
              kind: 'Hello World',
              subKind: 'Hello World',
              outOfStock: true,
              ingredient: {
                id: 'ad638aea-ed1f-48f9-96b9-982b62cbf4f5',
                name: 'Hello World',
                asset: { url: 'Hello World' },
                dietaryProperties: [
                  { id: '777aa9c9-114c-4022-8083-ecd361682050', name: 'DAIRY' },
                  { id: 'a44d7984-94b9-4a61-99b2-f355771adfbd', name: 'DAIRY' },
                  { id: 'a971c35e-72ce-48d8-9ed1-b6c16767c15e', name: 'DAIRY' },
                ],
              },
              mixable: false,
              isGrain: false,
            },
          ],
        },
        bread: {
          minAggregateQuantity: 56,
          maxAggregateQuantity: 58,
          freeAggregateQuantity: 51,
          allowMultipleQuantity: true,
          modifications: [
            {
              calories: -19.25,
              removalCost: -98.02,
              additionCost: 40.76,
              substitutionCost: -3.51,
              kind: 'Hello World',
              subKind: 'Hello World',
              outOfStock: true,
              ingredient: {
                id: 'cfc9748f-dd6f-4e2c-ae00-f99b4af482dd',
                name: 'Hello World',
                asset: { url: 'Hello World' },
                dietaryProperties: [
                  { id: '1fbdb34a-ad6f-4d28-8e53-b581470a074e', name: 'DAIRY' },
                  { id: '576e1562-b9e1-418b-9ae2-1f0b5fb84fcd', name: 'DAIRY' },
                ],
              },
              mixable: true,
              isGrain: false,
            },
            {
              calories: -26.31,
              removalCost: 44.43,
              additionCost: -8.76,
              substitutionCost: 41.74,
              kind: 'Hello World',
              subKind: 'Hello World',
              outOfStock: false,
              ingredient: {
                id: '2a37fd8c-d453-417c-9cdf-5537cb43cf3e',
                name: 'Hello World',
                asset: { url: 'Hello World' },
                dietaryProperties: [
                  { id: 'cf00cab3-1e45-4006-9160-6029c6de552f', name: 'DAIRY' },
                  { id: 'dbd0634f-156d-48b7-84fa-d52ffe2e3088', name: 'DAIRY' },
                  { id: '625969d4-5d7f-441d-af0c-5fc7567d5e43', name: 'DAIRY' },
                ],
              },
              mixable: false,
              isGrain: true,
            },
            {
              calories: 73,
              removalCost: 84.38,
              additionCost: 49.17,
              substitutionCost: 35.34,
              kind: 'Hello World',
              subKind: 'Hello World',
              outOfStock: true,
              ingredient: {
                id: 'd8af6948-5f94-4c66-90b7-2ad74549bedc',
                name: 'Hello World',
                asset: { url: 'Hello World' },
                dietaryProperties: [
                  { id: 'c8400665-d3b3-4072-8ccd-e8c32eb536ee', name: 'DAIRY' },
                  { id: '4738a06a-9bdc-43a6-b441-2cf3ae82ba7c', name: 'DAIRY' },
                  { id: 'f47a0508-daae-4e6d-ab3a-1abcd15dd6d9', name: 'DAIRY' },
                ],
              },
              mixable: false,
              isGrain: true,
            },
          ],
        },
      },
    },
  },
};
export const ProductIngredientFragmentDoc = gql`
  fragment ProductIngredient on Ingredient {
    id
    name
    asset {
      url
    }
    dietaryProperties {
      id
      name
    }
  }
`;
export const IngredientModificationFragmentDoc = gql`
  fragment IngredientModification on IngredientModification {
    calories
    removalCost
    additionCost
    substitutionCost
    kind
    subKind
    outOfStock
    ingredient {
      ...ProductIngredient
    }
    mixable
    isGrain
  }
  ${ProductIngredientFragmentDoc}
`;
export const IngredientModificationKindFragmentDoc = gql`
  fragment IngredientModificationKind on IngredientModificationKind {
    minAggregateQuantity
    maxAggregateQuantity
    freeAggregateQuantity
    allowMultipleQuantity
    modifications {
      ...IngredientModification
    }
  }
  ${IngredientModificationFragmentDoc}
`;
export const ProductDetailsFragmentDoc = gql`
  fragment ProductDetails on Product {
    id
    slug
    restaurantId
    name
    categoryId
    description
    cost
    calories
    outOfStock
    throttleItem
    maxModifications
    isModifiable
    isCustom
    asset {
      url
    }
    restaurant {
      id
      isOutpost
    }
    dietaryProperties {
      id
      name
    }
    ingredients {
      ...ProductIngredient
    }
    ingredientModifications {
      bases {
        ...IngredientModificationKind
      }
      toppings {
        ...IngredientModificationKind
      }
      premiums {
        ...IngredientModificationKind
      }
      dressings {
        ...IngredientModificationKind
      }
      bread {
        ...IngredientModificationKind
      }
    }
  }
  ${ProductIngredientFragmentDoc}
  ${IngredientModificationKindFragmentDoc}
`;
export const GetProductDocument = gql`
  query GetProduct($id: ID!) {
    product(id: $id) {
      ...ProductDetails
    }
  }
  ${ProductDetailsFragmentDoc}
`;

export function useGetProductQuery(
  options: Omit<Urql.UseQueryArgs<GetProductQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetProductQuery, GetProductQueryVariables>({
    query: GetProductDocument,
    ...options,
  });
}
